import React, { useState, useEffect } from "react";
import LayoutNew from "../../common/LayoutNew";
import { useDispatch, useSelector } from "react-redux";
import configs from "../../constants/configs";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";

export const TrangChu = () => {
  document.title = "Hệ thống đại lý";
  const dispatch = useDispatch();

  const danhmuc = useSelector((state) => state.danhmuc);
  const { objConfigAll } = danhmuc;

  useEffect(() => {
    dispatch(Index_GetConfigAllSTKey());
  }, []);

  useEffect(() => {
    if (objConfigAll.List.length > 0) {
      const configDailyDatHangVersion2 = objConfigAll.List.find(
        (e) =>
          e.KeyID.toUpperCase() ===
          configs.sKey.DAILY_DATHANG_VERSION2.toUpperCase(),
      );

      if (
        configDailyDatHangVersion2 != null &&
        configDailyDatHangVersion2.Value === "1"
      ) {
        window.location.href = "/DatHangDaiLy";
      }
    }
  }, [objConfigAll.List]);

  return (
    <LayoutNew>
      <div></div>
    </LayoutNew>
  );
};
